import React from 'react';
import { createUseStyles } from 'react-jss';

import { useToggle } from '../../../../hooks/useToggle';
import { listStringToObject } from '../../../../utils/utils';
import SeeMoreText from '../../../SeeMoreText';
import ToggleButton from '../../../ToggleButton';
import ProfileTitleExp from './ProfileTitleExp';

const useStyles = createUseStyles((theme) => ({
  profileTile: {},
  profileTileHeader: {
    composes: 'flexRow spaceBetween',
  },
  items: {
    padding: 0,
    margin: 0,
    '& > li': {
      listStyle: 'none',
      marginBottom: theme.spacing(1),
    },
  },
  about: {
    marginTop: theme.spacing(2),
  },
  title: {
    color: theme.colors.active,
    fontSize: 32,
    margin: 0,
    padding: 0,
    lineHeight: '1em',
  },
  longText: {},
  experiences: {
    marginTop: theme.spacing(2),
  },
}));

const ProfileTitle = ({ result }) => {
  const classes = useStyles();

  const { open, toggle } = useToggle();

  const experiences = listStringToObject(result?.us_exp_dic);

  return (
    <div className={classes.profileTile}>
      {result?.title && (
        <div className={classes.profileTileHeader}>
          <h2 className={classes.title}>
            {result?.title.raw}
          </h2>
        </div>
      )}

      {result?.pers_about && (
        <SeeMoreText 
          text={result?.pers_about.raw}
          label="About"
          className={result?.title ? classes.about : undefined}
        />
      )}

<     ul className={classes.items}>
        {experiences[0] && (
          <ProfileTitleExp
            result={result}
            data={experiences[0]}
            label="Experience 1 :"
          />
        )}
        {open && experiences.length > 1 && (
          <li>
            <ul className={classes.items}>
              {experiences.filter((_, i) => i !== 0).map((experience, index) => (
                <ProfileTitleExp
                  result={result}
                  data={experience}
                  label={"Experience "+ (index + 2) + ' : '}
                  key={index}
                />
              ))}
            </ul>
        </li>
        )}
        {experiences.length > 1 && (
          <li>
            <ToggleButton onClick={toggle} open={open} />
          </li>
        )}
      </ul>
    </div>
  );
}

export default ProfileTitle;